import { render, staticRenderFns } from "./LiveGoodsManager.vue?vue&type=template&id=b48b100c&scoped=true"
import script from "./LiveGoodsManager.vue?vue&type=script&lang=js"
export * from "./LiveGoodsManager.vue?vue&type=script&lang=js"
import style0 from "./LiveGoodsManager.vue?vue&type=style&index=0&id=b48b100c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48b100c",
  null
  
)

export default component.exports